export enum LookupColumnDataType {
  Number = 1,
  Text = 2,
  DateTime = 3,
  Boolean = 4,
  Radio = 5,
}
